<div>
    <p>dashboard works!</p>
</div>